import script from "./ChallengenMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengenMobile.vue?vue&type=script&setup=true&lang=js"

import "./ChallengenMobile.vue?vue&type=style&index=0&id=14b477fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b477fa"]])

export default __exports__